import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// --- 1. IMPORT KOMPONEN ---
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";

// --- 2. IMPORT HALAMAN ---
import SetDevice from "./pages/SetDevice"; // Halaman Public (Setup)
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ProfilSiswa from "./pages/ProfilSiswa";
import KuisSiswa from "./pages/KuisSiswa";
import NilaiSiswa from "./pages/NilaiSiswa";

// --- 3. IMPORT HALAMAN MANAJEMEN ---
import LaporanKeuangan from "./pages/LaporanKeuangan";
import DaftarSiswa from "./pages/DaftarSiswa";
import DetailSiswa from "./pages/DetailSiswa";
import KelolaEvaluasi from "./pages/KelolaEvaluasi";
import KelolaMateri from "./pages/KelolaMateri";
import KelolaTutor from "./pages/KelolaTutor";
import DaftarTutor from "./pages/DaftarTutor";
import KelolaAkun from "./pages/KelolaAkun";
import KelolaRelasi from "./pages/KelolaRelasi";
import GantiPassword from "./pages/GantiPassword";
import KelolaKuis from "./pages/KelolaKuis";
import KelolaMapel from "./pages/KelolaMapel";
import TagihanSiswa from "./pages/TagihanSiswa";
import MateriBelajar from "./pages/MateriBelajar";
import GuruAI from "./pages/GuruAI";
import GameCenter from "./pages/GameCenter";
import KelolaGamifikasi from "./pages/KelolaGamifikasi";

export default function App() {
  const [user, setUser] = useState(null);
  const [loadingCheck, setLoadingCheck] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem("ruangKelasUser");
    if (savedUser) setUser(JSON.parse(savedUser));
    setLoadingCheck(false);
  }, []);

  const handleLogin = (u) => {
    setUser(u);
    localStorage.setItem("ruangKelasUser", JSON.stringify(u));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("ruangKelasUser");
  };

  if (loadingCheck) return null; // Tunggu cek localStorage selesai

  return (
    <BrowserRouter>
      <Routes>
        {/* --- A. RUTE PUBLIK (BISA DIAKSES TANPA LOGIN) --- */}
        <Route path="/setup-secure-admin-v1" element={<SetDevice />} />

        {/* --- B. RUTE LOGIC UTAMA --- */}
        {/* Jika belum login, tampilkan Login Page. Jika sudah, tampilkan AppUtama */}
        <Route
          path="/*"
          element={
            !user ? (
              <LoginPage onLogin={handleLogin} />
            ) : (
              <AppUtama user={user} onLogout={handleLogout} />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

// --- KOMPONEN TERPISAH UNTUK HALAMAN SETELAH LOGIN ---
// (Agar kodingan App di atas tidak berantakan)
function AppUtama({ user, onLogout }) {
  const ROLE_ADMIN = ["admin", "kepala", "operator"];
  const ROLE_AKADEMIK = ["admin", "kepala", "operator", "tutor"];

  return (
    <>
      <Routes>
        {/* 1. AKSES UMUM */}
        <Route
          path="/"
          element={<Dashboard user={user} onLogout={onLogout} />}
        />
        <Route
          path="/profil"
          element={<ProfilSiswa user={user} onLogout={onLogout} />}
        />
        <Route path="/ganti-password" element={<GantiPassword />} />
        <Route path="/guru-ai" element={<GuruAI />} />
        <Route path="/materi" element={<MateriBelajar />} />
        <Route path="/list-tutor" element={<DaftarTutor />} />

        {/* 2. KHUSUS SISWA */}
        <Route
          path="/kuis-siswa"
          element={
            <ProtectedRoute user={user} allowedRoles={["siswa"]}>
              <KuisSiswa user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nilai"
          element={
            <ProtectedRoute user={user} allowedRoles={["siswa"]}>
              <NilaiSiswa user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tagihan-siswa"
          element={
            <ProtectedRoute user={user} allowedRoles={["siswa"]}>
              <TagihanSiswa />
            </ProtectedRoute>
          }
        />
        <Route
          path="/game"
          element={
            <ProtectedRoute user={user} allowedRoles={["siswa"]}>
              <GameCenter user={user} />
            </ProtectedRoute>
          }
        />

        {/* 3. MANAJEMEN AKADEMIK */}
        <Route
          path="/kelola-materi"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_AKADEMIK}>
              <KelolaMateri />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kelola-kuis"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_AKADEMIK}>
              <KelolaKuis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tulis-evaluasi"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_AKADEMIK}>
              <KelolaEvaluasi />
            </ProtectedRoute>
          }
        />

        {/* 4. MANAJEMEN ADMIN */}
        <Route
          path="/siswa"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_ADMIN}>
              <DaftarSiswa />
            </ProtectedRoute>
          }
        />
        <Route
          path="/siswa/:id"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_ADMIN}>
              <DetailSiswa />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tagihan-admin"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_ADMIN}>
              <LaporanKeuangan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kelola-gamifikasi"
          element={
            <ProtectedRoute
              user={user}
              allowedRoles={["admin", "kepala", "operator", "tutor"]}
            >
              <KelolaGamifikasi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kelola-tutor"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_ADMIN}>
              <KelolaTutor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kelola-relasi"
          element={
            <ProtectedRoute user={user} allowedRoles={ROLE_ADMIN}>
              <KelolaRelasi />
            </ProtectedRoute>
          }
        />

        {/* SUPER ADMIN */}
        <Route
          path="/kelola-akun"
          element={
            <ProtectedRoute user={user} allowedRoles={["admin", "kepala"]}>
              <KelolaAkun />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kelola-mapel"
          element={
            <ProtectedRoute user={user} allowedRoles={["admin", "kepala"]}>
              <KelolaMapel />
            </ProtectedRoute>
          }
        />

        {/* Redirect jika halaman tidak ditemukan */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <BottomNav />
    </>
  );
}
